module.exports = __webpack_public_path__ + "assets/paynl-secured.d8b07c70.svg";